import { PageEdit } from 'iconoir-react';
import React, {useRef, useState} from 'react'
import Popup from 'reactjs-popup';
import SignaturePad from "react-signature-canvas";
import Savesignature from './Savesignature';
import Termdata from '../../../../Views/OutLog/Terminos/Termdata';
import "./sigCanvas.css";
import Swal from 'sweetalert2';
import { domain, domain_need } from '../../../../Urls/Services/Api_urls';

const Signature_contract = (props) => {

    const groups = window.sessionStorage.getItem("groups");
    const token = window.sessionStorage.getItem("token");
    
    const tableMeta = props.tableMeta;
    const sigCanvas = useRef({});
    const limpiar = () => sigCanvas.current.clear();
    const [isToggled, setIsToggled] = useState(false);

    const guardarfirmabd = (tableMeta) => {
      if (
        sigCanvas.current.getTrimmedCanvas().toDataURL("image/png") !== null &&
        sigCanvas.current.getTrimmedCanvas().toDataURL("image/png").length >= 300
      ) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");
  
        var raw = JSON.stringify({
          signature: sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"),
          is_actived: "Firmado",
        });
  
        var requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
        fetch(
          domain + "/portal/" + tableMeta.id + "/update_signature/",
          requestOptions
        )
          .then((response) => response.text())
          .then((result) =>
            Swal.fire({
              title: "Adquirir proato firmado exitosamente",
              html: "Se ha firmado el contrato satisfactoriamente, se recargara la pagina en <b></b> milisegundos",
              icon: "success",
              showCancelButton: false,
              timer: 5000,
              allowOutsideClick: false,
              timerProgressBar: true,
              didOpen: () => {
                const b = Swal.getHtmlContainer().querySelector("b");
                setInterval(() => {
                  b.textContent = Swal.getTimerLeft();
                }, 100);
              },
              confirmButtonColor: "#3085d6",
              showConfirmButton: true,
              confirmButtonText: "Ver contrato",
            }).then((result) => {
              if (result.isConfirmed) {
                window.open(domain_need + "/PruebaDocData/" + tableMeta.id);
              }
              window.location.reload();
            })
          )
          .catch((error) => console.log("error", error));
      }
    };




    if (groups === "Usuario" || groups === "Usuario_Universidades") {
    //   setContractdis("disabled");
    //   setaddressdis("disabled");
      if (tableMeta.is_actived === "Por Firmar") {
        return (
          <div>
            <Popup
            //className='signature'
              modal
              trigger={
                <div style={{ cursor: "pointer" }}>
                  <button
                    className="btn72"
                    style={{ backgroundColor:"#619b40", color: "white", border: "none", height: "30px", width: "70px", padding: "2px", borderRadius:"0.5rem", transition: 'background-color 0.3s', cursor: 'pointer' }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#528711'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#619b40'}                 
                    title="Firmar contrato"
                  >
                    <PageEdit />
                    Firmar
                  </button>
                </div>
              }
            >
              {(close) => (
                <div style={{ backgroundColor: "#fff", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)", padding: "1rem", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: "2rem", borderRadius:"0.5rem", margin: "2rem" }}>
                  <h2>Realiza tu firma dentro del recuadro general</h2>
                  <SignaturePad
                    ref={sigCanvas}
                    canvasProps={{
                      className: "signatureCanvas",
                    }}
                  />
                  <div style={{display: "flex",gap: "1rem", width: "100%", justifyContent:"center"}}>
                    <input 
                      type="checkbox" 
                      onClick={() => setIsToggled(!isToggled)} 
                      className="cursor-pointer"
                    />
                    <button 
                      className="cursor-pointer text-red-950/70 rounded-xl hover:text-red-600 focus:outline-none focus:ring focus:ring-red-300 no-underline"
                      onClick={Termdata}
                    >
                      Acepto la política de tratamiento de datos
                    </button>
                  </div>
                  <div style={{display: "flex",gap: "1rem", width: "100%"}}>
                  <button style={{ backgroundColor: "#f87171", color: "white", borderRadius:"0.5rem", border: "none" }} onClick={close}>
                    <b>Cerrar</b>
                  </button>
                  <button style={{ backgroundColor: "#e5e5e5", color: "#374151", borderRadius:"0.5rem", border: "none" }}  onClick={limpiar}>
                    <b>Limpiar</b>
                  </button>
                  <button
                    style={{ backgroundColor: "#22c55e", color: "white", borderRadius:"0.5rem", border: "none" }} 
                    onClick={() => {
                      if (!isToggled) {
                        Swal.fire({
                          title: "Advertencia",
                          text: "Debes aceptar la política de tratamiento de datos antes de firmar.",
                          icon: "warning",
                          button: "Entendido",
                        });
                      } else {
                        guardarfirmabd(tableMeta);
                      }
                    }}
                  >
                    <b>Firmar</b>
                  </button>
                  </div>
                  
                </div>
              )}
            </Popup>
          </div>
        );
      }else {
        return null;
      }
    } else return null;
  };

  export default Signature_contract;